import EventEmitter from 'eventemitter3'

const luckyWheelEvents = new EventEmitter()

export default luckyWheelEvents
